import { render, staticRenderFns } from "./ModalBons.vue?vue&type=template&id=d83d4aac&"
import script from "./ModalBons.vue?vue&type=script&lang=js&"
export * from "./ModalBons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports